const BUBBLES = [
  {
    size: 7,
    left: '15%',
    opacity: 0.6,
    drift: '6px',
    duration: '3.5s',
    delay: '-0.5s',
  },
  {
    size: 11,
    left: '75%',
    opacity: 0.4,
    drift: '-5px',
    duration: '4.2s',
    delay: '-2s',
  },
  {
    size: 9,
    left: '-2%',
    opacity: 0.5,
    drift: '7px',
    duration: '4.8s',
    delay: '-3.5s',
  },
  {
    size: 12,
    left: '45%',
    opacity: 0.35,
    drift: '-4px',
    duration: '5s',
    delay: '-4s',
  },
  {
    size: 6,
    left: '90%',
    opacity: 0.6,
    drift: '3px',
    duration: '3.2s',
    delay: '-1.5s',
  },
] as const

export function ClaimableBubbles() {
  return (
    <div
      className="pointer-events-none absolute inset-0"
      style={{ overflow: 'visible' }}
    >
      {BUBBLES.map((b, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            width: b.size,
            height: b.size,
            bottom: 0,
            left: b.left,
            borderRadius: '50%',
            background: 'white',
            ['--bubble-opacity' as string]: b.opacity,
            ['--bubble-drift' as string]: b.drift,
            animation: `bubble-rise ${b.duration} ease-in-out infinite`,
            animationDelay: b.delay,
          }}
        />
      ))}
    </div>
  )
}
